var _line, _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckGearSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 37,
    y2: -1,
    transform: "matrix(1 4.37114e-08 4.37114e-08 -1 6 24)",
    stroke: "#B31B34",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    transform: "matrix(0 1 1 0 4 25)",
    fill: "#B31B34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 25,
    transform: "matrix(0 1 1 0 55 25)",
    fill: "#B31B34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 12.5L58.2831 14.895L62.3474 14.8875L63.5956 18.755L66.8881 21.1375L65.6249 25L66.8881 28.8625L63.5956 31.245L62.3474 35.1125L58.2831 35.105L54.9999 37.5L51.7168 35.105L47.6524 35.1125L46.4043 31.245L43.1118 28.8625L44.3749 25L43.1118 21.1375L46.4043 18.755L47.6524 14.8875L51.7168 14.895L54.9999 12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 25L53.75 28.125L60 21.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGearSmall);
export default __webpack_public_path__ + "static/media/check-gear-small.9f0e868b635f2a2423f5f7f57578bf69.svg";
export { ForwardRef as ReactComponent };